import { Action } from "../../../actions/actions";
import { GamesActionTypes } from "../actions/actionTypes";

export enum CreationModes {
    ADD = "ADD",
    EDIT = "EDIT"
}

export function attrCreationMode(state: string | null = null, action: Action) {
    switch (action.type) {
        case GamesActionTypes.CREATION_ATTR_MODE_CHANGE:
            return action.payload.mode;
        case GamesActionTypes.CREATE_GAME_ATTRIBUTE_SUCCESS:
        case GamesActionTypes.EDIT_GAME_ATTRIBUTE_SUCCESS:
            return null;
        default:
            return state;
    }
}

export function gameAttributesLoading(state: boolean = true, action: Action) {
    switch (action.type) {
        case GamesActionTypes.GET_GAME_ATTRIBUTES:
            return true;

        case GamesActionTypes.GET_GAME_ATTRIBUTES_FAIL:
        case GamesActionTypes.GET_GAME_ATTRIBUTES_SUCCESS:
            return false;

        default:
            return state;
    }
}

export function gameAttrFeatures(state: {} = {}, action: Action) {
    switch (action.type) {
        case GamesActionTypes.GET_GAME_ATTRIBUTES:
            return {};
        case GamesActionTypes.GET_GAME_ATTRIBUTES_FEATURES_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}

export function gameAttrFeaturesLoading(state: boolean = true, action: Action) {
    switch (action.type) {
        case GamesActionTypes.GET_GAME_ATTRIBUTES:
        case GamesActionTypes.GET_GAME_ATTRIBUTES_FEATURES:
            return true;

        case GamesActionTypes.GET_GAME_ATTRIBUTES_FEATURES_FAIL:
        case GamesActionTypes.GET_GAME_ATTRIBUTES_FEATURES_SUCCESS:
            return false;

        default:
            return state;
    }
}

export function gameAttrSeries(state: {} = {}, action: Action) {
    switch (action.type) {
        case GamesActionTypes.GET_GAME_ATTRIBUTES:
            return {};
        case GamesActionTypes.GET_GAME_ATTRIBUTES_SERIES_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}

export function gameAttrSeriesLoading(state: boolean = true, action: Action) {
    switch (action.type) {
        case GamesActionTypes.GET_GAME_ATTRIBUTES:
        case GamesActionTypes.GET_GAME_ATTRIBUTES_SERIES:
            return true;

        case GamesActionTypes.GET_GAME_ATTRIBUTES_SERIES_FAIL:
        case GamesActionTypes.GET_GAME_ATTRIBUTES_SERIES_SUCCESS:
            return false;

        default:
            return state;
    }
}

export function gameAttrPlatforms(state: {} = {}, action: Action) {
    switch (action.type) {
        case GamesActionTypes.GET_GAME_ATTRIBUTES:
            return {};
        case GamesActionTypes.GET_GAME_ATTRIBUTES_PLATFORM_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}

export function gameAttrPlatformsLoading(
    state: boolean = true,
    action: Action
) {
    switch (action.type) {
        case GamesActionTypes.GET_GAME_ATTRIBUTES:
        case GamesActionTypes.GET_GAME_ATTRIBUTES_PLATFORM:
            return true;

        case GamesActionTypes.GET_GAME_ATTRIBUTES_PLATFORM_FAIL:
        case GamesActionTypes.GET_GAME_ATTRIBUTES_PLATFORM_SUCCESS:
            return false;

        default:
            return state;
    }
}

export function gameAttrTypes(state: {} = {}, action: Action) {
    switch (action.type) {
        case GamesActionTypes.GET_GAME_ATTRIBUTES:
            return {};
        case GamesActionTypes.GET_GAME_ATTRIBUTES_TYPE_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}

export function gameAttrTypesLoading(state: boolean = true, action: Action) {
    switch (action.type) {
        case GamesActionTypes.GET_GAME_ATTRIBUTES:
        case GamesActionTypes.GET_GAME_ATTRIBUTES_TYPE:
            return true;

        case GamesActionTypes.GET_GAME_ATTRIBUTES_TYPE_FAIL:
        case GamesActionTypes.GET_GAME_ATTRIBUTES_TYPE_SUCCESS:
            return false;

        default:
            return state;
    }
}

export function gameAttrTrademarks(state: {} = {}, action: Action) {
    switch (action.type) {
        case GamesActionTypes.GET_GAME_ATTRIBUTES:
            return {};
        case GamesActionTypes.GET_GAME_ATTRIBUTES_TRADEMARKS_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}

export function gameAttrTrademarksLoading(
    state: boolean = true,
    action: Action
) {
    switch (action.type) {
        case GamesActionTypes.GET_GAME_ATTRIBUTES:
        case GamesActionTypes.GET_GAME_ATTRIBUTES_TRADEMARKS:
            return true;

        case GamesActionTypes.GET_GAME_ATTRIBUTES_TRADEMARKS_FAIL:
        case GamesActionTypes.GET_GAME_ATTRIBUTES_TRADEMARKS_SUCCESS:
            return false;

        default:
            return state;
    }
}

export function clients(state: {} = {}, action: Action) {
    switch (action.type) {
        case GamesActionTypes.GET_CLIENTS_SUCCESS:
            return action.payload.data;
        default:
            return state;
    }
}

export function clientsLoading(state: boolean = true, action: Action) {
    switch (action.type) {
        case GamesActionTypes.GET_CLIENTS:
            return true;

        case GamesActionTypes.GET_CLIENTS_FAIL:
        case GamesActionTypes.GET_CLIENTS_SUCCESS:
            return false;

        default:
            return state;
    }
}

export function attrCreationLoading(state: boolean = false, action: Action) {
    switch (action.type) {
        case GamesActionTypes.EDIT_GAME_ATTRIBUTE:
        case GamesActionTypes.CREATE_GAME_ATTRIBUTE:
            return true;

        case GamesActionTypes.EDIT_GAME_ATTRIBUTE_FAIL:
        case GamesActionTypes.EDIT_GAME_ATTRIBUTE_SUCCESS:
        case GamesActionTypes.CREATE_GAME_ATTRIBUTE_FAIL:
        case GamesActionTypes.CREATE_GAME_ATTRIBUTE_SUCCESS:
            return false;

        default:
            return state;
    }
}

export function gameCreationAttributesLoading(state: boolean = true, action: Action) {
    switch (action.type) {
        case GamesActionTypes.GET_GAME_CREATION_ATTRIBUTES:
            return true;
        case GamesActionTypes.GET_GAME_CREATION_ATTRIBUTES_FAIL:
        case GamesActionTypes.GET_GAME_CREATION_ATTRIBUTES_SUCCESS:
            return false;
        default:
            return state;
    }
}

export function gameCreationAttributes(state: {} = {}, action: Action) {
    switch (action.type) {
        case GamesActionTypes.GET_GAME_CREATION_ATTRIBUTES:
            return {};
        case GamesActionTypes.GET_GAME_CREATION_ATTRIBUTES_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}
